var _excluded = ["title", "icon", "iconBackground"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Div, Heading } from '@kizi/core-components';
import React from 'react';
import { IconV2 } from './IconV2';
export var HeadingWithIcon = function HeadingWithIcon(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      iconBackground = _ref.iconBackground,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Div, _extends({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }, restProps), /*#__PURE__*/React.createElement(Div, {
    variant: "circleWrapper",
    bg: iconBackground ? iconBackground : 'success'
  }, /*#__PURE__*/React.createElement(IconV2, _extends({
    size: 42
  }, icon))), /*#__PURE__*/React.createElement(Heading, {
    variant: "H2",
    as: "h2",
    textAlign: [null, null, null, 'center']
  }, title));
};